import styled from 'styled-components';

export const LeaderboardRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: ${({ $own }) => $own ? 'auto' : 'pointer'};
  width: 100%;
  gap: ${({ theme }) => theme.frameWidth};
  text-transform: uppercase;
  font-family: "BebasNeue";
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.4;
  color: black;
`;

export const LeaderInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  align-self: stretch;
  padding: 0 0.5rem;
  background: ${({ theme, $own, $selected }) => $own ? theme.baseRed : ($selected ? theme.selection : theme.buttonLightBlue)};
  transition: all linear .2s;

  &:hover {
    background: ${({ theme, $own, $selected }) => $own ? theme.baseRed : ($selected ? theme.selection : 'white')};
  }
`;

export const PlaceMarker = styled.div`
  width: 2.25rem;
  min-width: 2.25rem;
  height: 2.25rem;
  background: ${({ theme }) => theme.selection};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const ValueLabel = styled.div`
  padding-top: 4px;
`;

